import { LatLng } from "leaflet";
import CommandPasteShape from "../commands/PasteShape";
/**
 * Determines name for new area with auto-generated name
 */
export function determineNewAreaName(type, ids) {
    // gets all ares with auto generated names for type (e.g "Eli" for Circle)
    const areasWithAutoGeneratedNames = ids.filter(function (v) {
        return new RegExp(type).test(v);
    });
    // gets ending numbers of each string element and parses them to int
    // e.g ["Eli2", "Eli5", "Eli1"] to [2, 5, 1]
    const areaIds = [];
    areasWithAutoGeneratedNames.forEach(element => {
        const areaNumber = parseInt(element.replace(/[^-0-9.,]+/, ""));
        if (areaNumber > 0) {
            areaIds.push(areaNumber);
        }
    });
    // sorts [2, 5, 1] to [1, 2, 5]
    areaIds.sort((a, b) => a - b);
    // loops [1, 2, 5] n times to check if (i + 1) === areaIds[i] and if not
    // then returns it with (i + 1) for number
    for (let i = 0; i <= areaIds.length; i++) {
        if (areaIds[i] !== i + 1) {
            return type + (i + 1);
        }
    }
    return "";
}
/**
 * Calculates center point used for rotation of mass drawn areas
 */
export function getCenterPoint(massAreas) {
    // first area point needed to calculate center point for rotation
    const firstArea = [massAreas[0].center.lat, massAreas[0].center.lng];
    // last area point
    const lastArea = [
        massAreas[massAreas.length - 1].center.lat,
        massAreas[massAreas.length - 1].center.lng
    ];
    // center point lat lng
    return [(firstArea[0] + lastArea[0]) / 2, (firstArea[1] + lastArea[1]) / 2];
}
/**
 * Translate radians to degrees
 */
export function getDegrees(event, shapes) {
    const center = getCenterPoint(shapes);
    const radians = Math.atan2(event.latlng.lng - center[1], event.latlng.lat - center[0]);
    return Math.round(radians * (180 / Math.PI) * -1 + 100);
}
/**
 * Rotate points LatLng for shape - mass draw
 */
function rotatePoints(center, shapePoints, yaw, prevAngle) {
    // yaw is the angle moving left or right
    const degrees = prevAngle - yaw;
    const res = [];
    // conversion degrees to radians
    const radians = degrees * (Math.PI / 180);
    for (let i = 0; i < shapePoints.length; i++) {
        const p = shapePoints[i];
        // translate to center
        const p2 = [p[0] - center[0], p[1] - center[1]];
        // rotate using matrix rotation
        const p3 = [
            Math.cos(radians) * p2[0] - Math.sin(radians) * p2[1],
            Math.sin(radians) * p2[0] + Math.cos(radians) * p2[1]
        ];
        // translate back to center
        const p4 = [p3[0] + center[0], p3[1] + center[1]];
        // done with that point
        res.push(p4);
    }
    return res;
}
/**
 * Uses params from ShapeManager to update the angle of rotation for shapes and markers
 */
export function updateRotationAngle(degrees, prevAngle, marker, shapes) {
    // rotation angle
    const yawAngle = degrees;
    // mass drawn areas
    const massAreas = shapes;
    // center point
    const centerPoint = getCenterPoint(massAreas);
    massAreas.forEach(shape => {
        // LatLng values for the shape
        const shapePoints = [[shape.center.lat, shape.center.lng]];
        // new coords for area during rotation
        const shapeRotated = rotatePoints(centerPoint, shapePoints, yawAngle, prevAngle);
        // shape.moveShape needs only the difference
        shape.moveShape(new LatLng(shapeRotated[0][0] - shape.center.lat, shapeRotated[0][1] - shape.center.lng));
    });
    // rotate marker according to yaw angle
    const markerPoint = [[marker.getLatLng().lat, marker.getLatLng().lng]];
    const markerRotated = rotatePoints(centerPoint, markerPoint, yawAngle, prevAngle);
    marker.setLatLng([markerRotated[0][0], markerRotated[0][1]]);
    return yawAngle;
}
/**
 * Generates well names. A well name is made of a letter and a number (ex: 'A1').
 * letterIndex is used to give a letter to each row.
 * numberIndex is used to give a number to each well of a row.
 */
export function generateWellNames(wellplateDetails) {
    const areaNames = [];
    for (let letterIndex = 0; letterIndex < wellplateDetails.nrOfRows; letterIndex++) {
        for (let numberIndex = 0; numberIndex < wellplateDetails.nrOfColumns; numberIndex++) {
            const areaName = `${String.fromCharCode(65 + letterIndex)}${numberIndex + 1}`;
            areaNames.push(areaName);
        }
    }
    return areaNames;
}
export function pasteShape(manager) {
    // paste is possible only for unprocessed areas
    const allowPaste = Object.keys(manager.copiedShape.leadingShape || manager.copiedShape)
        .length > 0;
    if (allowPaste) {
        manager.addCommand(new CommandPasteShape(manager.copiedShape));
        manager.copiedShape.moveShape(new LatLng(manager.mouseLocation.lat - manager.copiedShape.getCenter().lat, manager.mouseLocation.lng - manager.copiedShape.getCenter().lng));
        manager.setActive(manager.copiedShape.leadingShape || manager.copiedShape);
    }
}
